const _st = { onLeave: {}, onEnter: {}, modalId: 0, onModalLeave: {} }
export class BenHash {
  static init() {
    window.addEventListener('hashchange', (e) => {
      const metaVp = document.querySelector('meta[name="viewport"]') as HTMLMetaElement
      metaVp.content = 'width=device-width,initial-scale=1'
      window.onhashchange = () => {
        metaVp.content = ''
        metaVp.content = 'width=device-width,initial-scale=1'
      }
      const { oldHash, newHash } = _getHashKey(e)
      const onLeaveFn = _st.onLeave[oldHash]
      const onEnterFn = _st.onEnter[newHash]
      if (onLeaveFn) onLeaveFn({ newHash, oldHash })
      if (onEnterFn) onEnterFn({ newHash, oldHash })
      if (newHash.startsWith('m-')) {
        const newNumber = Number(newHash.split('-')[1])
        for (let key in _st.onModalLeave) {
          const keyNumber = Number(key.split('-')[1])
          if (keyNumber > newNumber) _st.onModalLeave[key]()
        }
      } else {
        for (let key in _st.onModalLeave) {
          _st.onModalLeave[key]()
        }
      }
    })
  }
  static onLeave(key: string, callback) {
    _st.onLeave[key] = callback
  }
  static onEnter(key: string, callback) {
    _st.onEnter[key] = callback
  }
  static push(key: string) {
    window.location.hash = key
  }
  static getHash() {
    return window.location.hash.slice(1)
  }
  static goback() {
    window.history.back()
  }
  static pushModal(onLeave: Function) {
    const id = ++_st.modalId
    const hash = `m-${id}`
    BenHash.push(hash)
    _st.onModalLeave[hash] = onLeave
  }
}

function _getHashKey(e: HashChangeEvent) {
  const newHash = e.newURL.split('#')[1] || 'EMPTY'
  const oldHash = e.oldURL.split('#')[1] || 'EMPTY'
  return { newHash, oldHash }
}
